import React from 'react';
import Divider from '@mui/material/Divider';
import { List, ListItem } from '@mui/material';


export default function AlertsList() {

  let notifications = []

  return (
    <React.Fragment>

      <List
        id="alert-list"
      >
        {notifications.length > 0 &&
          notifications.map((notification) => {
            return (
              <div key={notification.id}>
                <ListItem key={notification.id} >
                  {notification.notification}
                </ListItem>
                <Divider />
              </div>)
          })}
      </List>
    </React.Fragment>
  );
}
